// extracted by mini-css-extract-plugin
module.exports = {"loader":"style_loader__3TxWn","fullScreen":"style_fullScreen__gTGKg","hidden":"style_hidden__16ADe"};